import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../models/Globals';

@Component({
	selector: 'filtration-result-message',
	templateUrl: './filtration-result-message.component.html',
	styleUrls: [],
})
export class FiltrationResultMessageComponent implements OnInit {
	globals=Globals;
    _showFiltrationCount;
	@Input()
	set ShowFiltrationCount(val: any) {
		this._showFiltrationCount = val;
	}

	_count;
	@Input()
	set Count(val: any) {
		this._count = val;
	}

	_totalCount;
	@Input()
	set TotalCount(val: any) {
		this._totalCount = val;
	}

	ngOnInit(): void {

	}

	constructor() {
	}

}


